import { connect } from 'react-redux';
import { AppDispatch, RootState } from 'src/store/store';
import UnloadFooter from 'src/components/pages/unload-page/unload-footer/UnloadFooter';
import { closeBoundContainer, endOrphan, returnToSidelineId, showSideline,
    startOrphan } from 'src/store/common-slices/unloadSlice';

const mapStateToProps = (state: RootState) => ({
    pageToRender: state.Unload.pageToRender,
    inPallet: state.Unload.trailer?.palletId !== undefined,
    callPending: state.Unload.pending
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    startOrphan: () => dispatch(startOrphan()),
    returnToSidelineId: () => dispatch(returnToSidelineId()),
    endOrphan: () => dispatch(endOrphan()),
    showSideline: (open: boolean) => dispatch(showSideline(open)),
    closeBoundContainer: () => dispatch(closeBoundContainer())
});

export default connect(mapStateToProps, mapDispatchToProps)(UnloadFooter);
